import { Component } from '@angular/core';
import { ORCIDMembershipEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Memberships') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orcidmembership-form',
    templateUrl: './orcidmembership.form.component.html'
})
export class ORCIDMembershipFormComponent extends BaseFormComponent {
    public record!: ORCIDMembershipEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

